export class AccountType {
  accountTypeId?: any;
  accountTypeName: string;

  constructor() {
    this.accountTypeName = "";
  }
}
